import angular, { isDate } from 'angular';
import isEmpty from 'lodash/isEmpty';

import * as actions from '../../../store/actions';

const mapStateToScope = (state) => ({
  subComponent: state.statsbar.activeComponent,
  activePromotionCode: state.promotion.activePromotionCode,
  allMemberTiers: state.tiers.allMemberTiers,
});

angular
  .module('myConsultApp')
  .controller('promotionCodeController', ($rootScope, $scope, $ngRedux, $http, ENV, $timeout) => {
    $scope.getMemberTierData = () => {
      $scope
        .getAllMemberTiers($http, ENV)
        .then((response) => {
          $scope.availableTiers = response.map((tier) => {
            return {
              ...tier,
              isActive: false,
              isEditing: false,
              value: null,
            };
          });
          if ($scope.activePromotionCode) {
            $scope.loadActivePromoCodePointData();
          }
        })
        .catch((error) => {
          console.warn(error);
        });
    };

    $scope.loadActivePromoCodePointData = () => {
      $scope.availableTiers.forEach((tier) => {
        const type = $scope.pointType === 'fixed' ? 'num_points' : 'point_multiplier';
        const isObject = typeof $scope.activePromotionCode.point_data[type] === 'object';
        const memberTiers = $scope.activePromotionCode.member_tiers.map((t) => {
          return t.id;
        });
        tier.value = isObject
          ? $scope.activePromotionCode.point_data[type][tier.slug]
          : $scope.activePromotionCode.point_data[type];
        tier.isActive = memberTiers.includes(tier.id);
        $scope.promotionCode[type] = Number($scope.activePromotionCode.point_data[type].base_value);
      });
    };

    $scope.initData = () => {
      $scope.title = 'Create Promotion Code';
      $scope.activityTypeDates = [];
      $scope.setActivePromotionCode({});
      $scope.getMemberTierData();
      $scope.promotionCode = {
        code: '',
        num_points: null,
        point_multiplier: null,
        brands_rule: null,
        skus_rule: null,
        apply_to_multiple_pets: false,
        first_time_purchase_user: false,
        first_time_purchase_pet: false,
        first_time_purchase_clinic: false,
        frequency_cap_user: 0,
        frequency_cap_pet: 0,
        frequency_cap_pet_and_brand: 0,
        type: null,
        organizations: [],
        brands: [],
        products: [],
        activities: [],
      };
      $scope.promotionCodeTypes = [
        { name: 'Invoice Code', slug: 'invoice_code' },
        { name: 'Registration Code', slug: 'registration_code' },
      ];
      $scope.promotionCodeRules = [
        { title: 'No Rule', slug: null },
        { title: 'OR', slug: 'OR' },
        { title: 'AND', slug: 'AND' },
      ];
      $scope.organizations = [];
      $scope.organization_ids = [];
      $scope.brands = [];
      $scope.brand_ids = [];
      $scope.brands_rule = null;
      $scope.brandMinDoses = [];
      $scope.products = [];
      $scope.product_ids = [];
      $scope.productMinDoses = [];
      $scope.activityTypes = [];
      $scope.activity_ids = [];
      $scope.pointType = 'fixed';
      $scope.skus_rule = null;
      $scope.errors = [];
      $scope.promotionCodeProcessing = false;
      $scope.isPromotionCodeReady = true;
    };

    $scope.unsetTierPointDataValues = (type) => {
      const isMatch =
        $scope.activePromotionCode && $scope.activePromotionCode?.point_data?.[type] !== null;
      $scope.pointType = type === 'num_points' ? 'fixed' : 'multiplier';
      $scope.promotionCode[type] = $scope.activePromotionCode?.point_data?.[type]?.base_value
        ? $scope.activePromotionCode?.point_data?.[type]?.base_value
        : null;
      $scope.availableTiers.forEach((item, index) => {
        const value = $scope.activePromotionCode?.point_data?.[type]?.[item.slug] || null;
        $scope.availableTiers[index].value = isMatch ? value : null;
      });
    };

    $scope.selectPointTier = (index) => {
      $scope.availableTiers[index].isActive = !$scope.availableTiers[index].isActive;
    };

    $scope.toggleIsEditing = (index) => {
      $scope.availableTiers[index].isEditing = !$scope.availableTiers[index].isEditing;
    };

    $scope.init = () => {
      $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
    };

    $scope.selectPromotionCodeType = (option) => {
      $scope.promotionCode.type = option;
    };

    $scope.selectBrandsRule = (option) => {
      $scope.brands_rule = option.slug;
    };

    $scope.selectProductsRule = (option) => {
      $scope.skus_rule = option.slug;
    };

    $scope.setPromotionCodeProcessing = (item) => {
      $scope.isPromotionCodeReady = item;
    };

    $scope.searchPromoteOrganizations = (query) => {
      return $scope
        .searchOrganization($http, ENV, {
          directory_type: '1,2',
          order: '-date_created',
          search: query,
        })
        .then((res) => res);
    };

    $scope.searchPromoteOrganizationsPage = (query) => {
      return $scope.searchOrganizationByUrl($http, query).then((res) => res);
    };

    $scope.selectOrganization = (item) => {
      $scope.triggerInput('promotion-code-organization-search', '');
      $scope.organizations.push(item);
      $scope.organization_ids.push(item.id);
    };

    $scope.removeOrganization = (index) => {
      $scope.organizations.splice(index, 1);
      $scope.organization_ids.splice(index, 1);
    };

    $scope.searchPromoteBrands = (query) => {
      return $scope
        .searchBrand($http, ENV, {
          paginate: true,
          page_size: 25,
          search: query,
        })
        .then((res) => res);
    };

    $scope.searchPromoteBrandsByUrl = (query) => {
      return $scope.searchBrandByUrl($http, query).then((res) => res);
    };

    $scope.selectBrand = (item) => {
      $scope.triggerInput('promotion-code-brand-search', '');
      $scope.brands.push({
        ...item,
        min_doses: null,
      });
      $scope.brand_ids.push(item.id);
      $scope.brandMinDoses.push({
        val: 0,
        error: '',
      });
    };

    $scope.removeBrand = (index) => {
      $scope.brands.splice(index, 1);
      $scope.brand_ids.splice(index, 1);
      $scope.brandMinDoses.splice(index, 1);
    };

    $scope.editBrandMinDose = (index) => {
      $scope.brands[index].min_doses = null;
    };

    $scope.checkBrandMinDose = (index) => {
      $scope.brands[index].min_doses = $scope.brandMinDoses[index].val;
    };

    $scope.searchPromoteProducts = (query) => {
      return $scope
        .searchProduct($http, ENV, {
          paginate: true,
          page_size: 25,
          search: query,
          organizations: 'all',
        })
        .then((res) => res);
    };

    $scope.searchPromoteProductsPage = (query) => {
      return $scope.searchProductByUrl($http, query).then((res) => res);
    };

    $scope.selectProduct = (item) => {
      $scope.triggerInput('promotion-code-product-search', '');
      $scope.products.push({
        ...item,
        min_doses: null,
      });
      $scope.product_ids.push(item.skus.id);
      $scope.productMinDoses.push({
        val: 0,
        error: '',
      });
    };

    $scope.removeProduct = (index) => {
      $scope.products.splice(index, 1);
      $scope.product_ids.splice(index, 1);
      $scope.productMinDoses.splice(index, 1);
    };

    $scope.editProductMinDose = (index) => {
      $scope.products[index].min_doses = null;
    };

    $scope.checkProductMinDose = (index) => {
      $scope.products[index].min_doses = $scope.productMinDoses[index].val;
    };

    $scope.searchPromoteActivityTypes = (query) => {
      let classification_id = '';
      if ($scope.promotionCode.type && $scope.promotionCode.type.slug === 'invoice_code') {
        classification_id = 3;
      } else if (
        $scope.promotionCode.type &&
        $scope.promotionCode.type.slug === 'registration_code'
      ) {
        classification_id = 2;
      }
      return $scope
        .getUserActivityTypes($http, ENV, {
          paginate: true,
          status: 'enabled,disabled',
          order: 'title',
          search: query,
          classification_id: classification_id,
        })
        .then((res) => res);
    };

    $scope.searchPromoteActivityTypesPage = (query) => {
      return $scope.getUserActivityTypesByUrl($http, query).then((res) => res);
    };

    $scope.selectActivityType = (item) => {
      $scope.triggerInput('promotion-code-activity-type-search', '');
      $scope.activityTypes.push(item);
      $scope.activity_ids.push(item.id);
      angular.forEach($scope.activityTypeDates, (activity_type, activity_type_index) => {
        $scope.activityTypeDates[activity_type_index].editing = false;
      });
      $scope.activityTypeDates.push({
        editing: true,
        start_date: 'none',
        end_date: 'none',
        start_date_purchased: 'none',
        end_date_purchased: 'none',
        code_cap: 0,
      });
    };

    $scope.removeActivityType = (index) => {
      $scope.activityTypes.splice(index, 1);
      $scope.activity_ids.splice(index, 1);
    };

    $scope.editActivityType = (index) => {
      angular.forEach($scope.activityTypeDates, (activity_type, activity_type_index) => {
        if (activity_type_index !== index) {
          $scope.activityTypeDates[activity_type_index].editing = false;
        }
      });
      $scope.activityTypeDates[index].editing = true;
    };

    $scope.checkActivityType = (index) => {
      $scope.activityTypeDates[index].editing = false;
    };

    $scope.applySuccess = (keepPage) => {
      $scope.promotionCodeProcessing = false;
      $scope.errors = [];
      $scope.close(keepPage);
    };

    $scope.applyError = (error) => {
      $scope.promotionCodeProcessing = false;
      $scope.errors = $scope.processErrors(error.data['promotion-code']);
    };

    $scope.processErrors = (errors) => {
      const result = [];
      if (Array.isArray(errors)) errors = errors[0];
      if (!isEmpty(errors)) {
        Object.entries(errors).forEach((key, value) => {
          const keyString = key
            .split('_')
            .map((item) => $scope.capitalize(item))
            .join(' ');
          if (Array.isArray(value)) {
            result.push(...value.map((item) => `${keyString}: ${item}`));
          } else if (typeof value === 'object') {
            result.push(`${keyString}: ${Object.values(value)[0]}`);
          } else {
            result.push(`${keyString}: ${value}`);
          }
        });
      }
      return result;
    };

    $scope.prepareSubmissionPointData = () => {
      const baseValue =
        $scope.pointType === 'fixed'
          ? $scope.promotionCode.num_points
          : $scope.promotionCode.point_multiplier;
      const type = $scope.pointType === 'fixed' ? 'num_points' : 'point_multiplier';
      const otherType = type === 'num_points' ? 'point_multiplier' : 'num_points';
      const pointData = $scope.availableTiers
        .filter((tier) => {
          return tier.isActive;
        })
        .map(({ slug, value }) => {
          return {
            [slug]: value,
          };
        });
      return {
        [type]: [{ base_value: baseValue }, ...pointData].reduce((result, item) => {
          var key = Object.keys(item)[0];
          if (item[key] !== null) result[key] = item[key];
          return result;
        }, {}),
        [otherType]: null,
      };
    };

    $scope.prepareSubmissionTierData = () => {
      const tiers = $scope.availableTiers
        .map(({ id, isActive }) => {
          return isActive ? id : null;
        })
        .filter((value) => {
          return value !== null;
        });
      return tiers;
    };

    $scope.submitPromotionCode = () => {
      $scope.submissionCode = angular.copy($scope.promotionCode);
      if ($scope.submissionCode.type.slug === 'invoice_code') {
        $scope.submissionCode.point_data = $scope.prepareSubmissionPointData();
        $scope.submissionCode.member_tiers = $scope.prepareSubmissionTierData();
      }

      delete $scope.submissionCode.num_points;
      delete $scope.submissionCode.point_multiplier;

      if (
        $scope.organizations.length &&
        $scope.promotionCode.type &&
        $scope.promotionCode.type.slug === 'invoice_code'
      ) {
        $scope.submissionCode.organizations = $scope.organization_ids;
      } else {
        $scope.submissionCode.organizations = [];
      }

      if (
        $scope.brands.length &&
        $scope.promotionCode.type &&
        $scope.promotionCode.type.slug === 'invoice_code'
      ) {
        $scope.submissionCode.brands = $scope.brands
          .map((brand) => ({
            id: brand.id,
            min_doses: brand.min_doses,
          }))
          .filter((brand) => brand.min_doses !== null && brand.min_doses !== '');
      } else {
        $scope.submissionCode.brands = [];
      }

      if (
        $scope.products.length &&
        $scope.promotionCode.type &&
        $scope.promotionCode.type.slug === 'invoice_code'
      ) {
        $scope.submissionCode.products = $scope.products
          .map((product) => ({
            id: product.skus.id,
            min_doses: product.min_doses,
          }))
          .filter((product) => product.min_doses !== null && product.min_doses !== '');
      } else {
        $scope.submissionCode.products = [];
      }

      if ($scope.activityTypes.length) {
        $scope.submissionCode.activities = $scope.activityTypes.map((activity) => ({
          id: activity.id,
          start_date: activity.start_date !== '' ? activity.start_date : null,
          end_date: activity.end_date !== '' ? activity.end_date : null,
          start_date_purchased:
            activity.start_date_purchased !== '' &&
            $scope.promotionCode.type &&
            $scope.promotionCode.type.slug === 'invoice_code'
              ? activity.start_date_purchased
              : null,
          end_date_purchased:
            activity.end_date_purchased !== '' &&
            $scope.promotionCode.type &&
            $scope.promotionCode.type.slug === 'invoice_code'
              ? activity.end_date_purchased
              : null,
          code_cap:
            activity.code_cap !== '' &&
            $scope.promotionCode.type &&
            $scope.promotionCode.type.slug === 'registration_code'
              ? activity.code_cap
              : 0,
        }));
      } else {
        $scope.submissionCode.activities = [];
      }

      if ($scope.promotionCode.type) {
        $scope.submissionCode.type = $scope.promotionCode.type.slug;
      }

      if (
        $scope.brands_rule &&
        $scope.promotionCode.type &&
        $scope.promotionCode.type.slug === 'invoice_code'
      ) {
        $scope.submissionCode.brands_rule = $scope.brands_rule;
      } else {
        $scope.submissionCode.brands_rule = null;
      }

      if (
        $scope.skus_rule &&
        $scope.promotionCode.type &&
        $scope.promotionCode.type.slug === 'invoice_code'
      ) {
        $scope.submissionCode.skus_rule = $scope.skus_rule;
      } else {
        $scope.submissionCode.skus_rule = null;
      }

      $scope.promotionCodeProcessing = true;
      if (isEmpty($scope.activePromotionCode)) {
        $scope
          .createPromotionCode($http, ENV, {
            'promotion-code': $scope.submissionCode,
          })
          .then(() => {
            $timeout(() => {
              $scope.applySuccess(false);
            });
          })
          .catch((error) => {
            $timeout(() => {
              $scope.applyError(error);
            });
          });
      } else {
        $scope
          .updatePromotionCode(
            $http,
            ENV,
            {
              'promotion-code': $scope.submissionCode,
            },
            $scope.promotionCode.id,
          )
          .then(() => {
            $timeout(() => {
              $scope.applySuccess(true);
            });
          })
          .catch((error) => {
            $timeout(() => {
              $scope.applyError(error);
            });
          });
      }
    };

    // This function should be in the root scope
    $scope.triggerInput = (id, val) => {
      const e = document.getElementById(`${id}_value`);
      if (e) {
        e.value = val;
        angular.element(e).triggerHandler('input');
      }
    };

    $scope.updateActivityDate = (index, name, val) => {
      const types = [...$scope.activityTypes];
      types[index][name] = val;
      $scope.activityTypes = types;
      $scope.activityTypeDates[index][name] = val && val !== '' ? val : 'none';
    };

    const subComponentListener = $scope.$watch('subComponent', ({ oldVal }) => {
      if (oldVal === 'create-promotion-code' || oldVal === 'edit-promotion-code') {
        $scope.initData();
        $scope.triggerInput('promotion-code-organization-search', '');
        $scope.triggerInput('promotion-code-brand-search', '');
        $scope.triggerInput('promotion-code-product-search', '');
        $scope.triggerInput('promotion-code-activity-type-search', '');
      }
    });

    const pointTypeListener = $scope.$watch('pointType', () => {
      if ($scope.pointType === 'fixed') {
        $scope.promotionCode.point_multiplier = null;
      } else {
        $scope.promotionCode.num_points = null;
      }
    });

    const activePromotionCodeListener = $scope.$watch('activePromotionCode', () => {
      if (!isEmpty($scope.activePromotionCode)) {
        $scope.title = 'Edit Promotion Code';
        $scope.promotionCode = {
          ...$scope.activePromotionCode,
          brands_rule: {
            title: $scope.activePromotionCode.brands_rule || 'No Rule',
            slug: $scope.activePromotionCode.brands_rule,
          },
          skus_rule: {
            title: $scope.activePromotionCode.skus_rule || 'No Rule',
            slug: $scope.activePromotionCode.skus_rule,
          },
        };
        $scope.pointType = $scope.activePromotionCode.point_data.point_multiplier
          ? 'multiplier'
          : 'fixed';
        $scope.organizations = angular.copy($scope.activePromotionCode.organizations);
        $scope.organization_ids = $scope.organizations.map((organization) => organization.id);
        $scope.brands = $scope.activePromotionCode.brands.map(({ brand, ...other }) => ({
          ...brand,
          ...other,
          brand: brand.name,
          min_doses: String(other.min_doses),
        }));
        $scope.brand_ids = $scope.brands.map((brand) => brand.id);
        $scope.products = $scope.activePromotionCode.products.map(({ product, ...other }) => ({
          ...other,
          ...product.brand,
          id: product.id,
          skus: product,
          brand: product.brand.name,
          min_doses: String(other.min_doses),
        }));
        $scope.product_ids = $scope.products.map((product) => String(product.id));
        $scope.activityTypes = $scope.activePromotionCode.activities.map(
          ({ activity, ...other }) => ({
            ...activity,
            ...other,
            start_date: other.start_date,
            end_date: other.end_date,
            start_date_purchased: other.start_date_purchased,
            end_date_purchased: other.end_date_purchased,
            code_cap: other.code_cap,
          }),
        );
        $scope.activity_ids = $scope.activityTypes.map((activityType) => activityType.id);
        $scope.activityTypeDates = $scope.activePromotionCode.activities.map(
          ({ activity, ...other }) => ({
            editing: false,
            start_date: other.start_date ? other.start_date : 'none',
            end_date: other.end_date ? other.end_date : 'none',
            start_date_purchased: other.start_date_purchased ? other.start_date_purchased : 'none',
            end_date_purchased: other.end_date_purchased ? other.end_date_purchased : 'none',
            code_cap: other.code_cap ? other.code_cap : 0,
          }),
        );
        $scope.brandMinDoses = $scope.activePromotionCode.brands.map(({ brand, ...other }) => ({
          val: other.min_doses,
          error: '',
        }));
        $scope.productMinDoses = $scope.activePromotionCode.products.map(
          ({ product, ...other }) => ({
            val: other.min_doses,
            error: '',
          }),
        );
        $scope.brands_rule = $scope.activePromotionCode.brands_rule
          ? $scope.activePromotionCode.brands_rule
          : null;
        $scope.skus_rule = $scope.activePromotionCode.skus_rule
          ? $scope.activePromotionCode.skus_rule
          : null;
        $scope.getMemberTierData();
      }
    });

    $scope.close = (keepPage, refresh = true) => {
      $scope.initData();
      $rootScope.closeComponent();
      if (refresh) {
        $timeout(() => {
          $rootScope.getData(keepPage);
        });
      }
    };

    $scope.init();
    $scope.initData();
    $scope.$on('$destroy', () => {
      $scope.unsubscribe();
      activePromotionCodeListener();
      pointTypeListener();
      subComponentListener();
    });
  })
  .directive('promotionCodeCreateEdit', () => {
    return {
      templateUrl: 'templates/v2/promotion-code-create-edit.html',
    };
  });
